import React from "react";
import HomePage from "../components/public/home/HomePage";
import "../styles/public-experience.css";
import "../styles/public-home-premium.css";

export default function Home() {
  return <HomePage />;
}
